import { put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { getSnaps, exportSnap, addSnap, deleteSnap, editSnap } from './service';
import {
	getSnapsSuccessAction,
	getSnapsFailureAction,
	addSnapSuccessAction,
	addSnapFailureAction,
	deleteSnapSuccessAction,
	deleteSnapFailureAction,
	editSnapSuccessAction,
	editSnapFailureAction,
} from './action';

export function* getSnapsSaga(action: any) {
	try {
		const { page = 1 } = action.payload;
		const { data }: AxiosResponse = yield getSnaps(page);
		yield put(getSnapsSuccessAction(data.data));
	} catch (e) {
		yield put(getSnapsFailureAction(e as Error));
	}
}

export function* exportSnapSaga(action: any) {
	const { id, showSuccessModal, showFailModal } = action.payload;
	try {
		const { data }: AxiosResponse = yield exportSnap(id);
		if (!data.data) throw new Error('Smth went wrong');
		yield showSuccessModal();
	} catch (e) {
		yield showFailModal();
	}
}

export function* addSnapSaga(action: any) {
	const { text, showSuccessModal, showFailModal } = action.payload;
	try {
		const { data }: AxiosResponse = yield addSnap(text);
		if (!data.data.isSuccessful) throw new Error('Not Successful');
		yield put(addSnapSuccessAction(data.data));
		yield showSuccessModal();
	} catch (e) {
		yield put(addSnapFailureAction(e as Error));
		yield showFailModal();
	}
}

export function* editSnapSaga(action: any) {
	const { data: payload, callback } = action.payload;
	try {
		const { data }: AxiosResponse = yield editSnap(payload);
		yield put(editSnapSuccessAction(data.data));
	} catch (e) {
		yield put(editSnapFailureAction(e as Error));
	} finally {
		callback && callback();
	}
}

export function* deleteSnapSaga(action: any) {
	const { _id, callback } = action.payload;
	try {
		yield deleteSnap(_id);
		yield put(deleteSnapSuccessAction(_id));
	} catch (e) {
		yield put(deleteSnapFailureAction(e as Error));
	} finally {
		callback && callback();
	}
}
